import React from 'react';
import { useHistory } from 'react-router-dom';
import { CardContainer, CardTitle, ImageContainer, CardImage } from './styles';

export interface PageCardProps {
  title: string;
  imageSrc: string;
  to?: string;
  onClick?(): void;
}

const PageCard: React.FC<PageCardProps> = ({
  title,
  imageSrc,
  to,
  onClick,
}) => {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (to) {
      history.push(to);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <CardContainer
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={title}
    >
      <CardTitle>{title}</CardTitle>
      <ImageContainer>
        <CardImage src={imageSrc} />
      </ImageContainer>
    </CardContainer>
  );
};

export default PageCard;
